// extracted by mini-css-extract-plugin
export default {"Markdown":"Markdown__Markdown-Pt82F"};